/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import AbstractModule from "../abstract_module";
import Annotation from "./annotation";
import {RenderDocument} from "js_renderer";
import {vec2} from "gl-matrix";
import IAnnotationsModule from "./scene_annotations_interface";
import Scene from "../../scene";

export interface IAnnotations {
    [index: number]: Annotation;
}

export default
class AnnotationsModule extends AbstractModule implements IAnnotationsModule{

    protected static _typeName: string = "annotations";

    private _annotations: IAnnotations;

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);
        this._type = AnnotationsModule._typeName;

        this._annotations = {};

        let view = this.sceneAPI.viewModeModule.getActiveView();
        if (view) {
            view.registerViewResizedObserver(this);
            view.registerViewChangedObserver(this);
        }
    }

    public static getClassType(): string {
        return AnnotationsModule._typeName;
    }

    public addAnnotation(aScreenCssPositionX: number, aScreenCssPositionY: number, aCallback: any): Annotation {
        let view = this.sceneAPI.viewModeModule.getActiveView();
        if (!view) {
            return null;
        }

        let annotation = new Annotation(this.renderDocument, aScreenCssPositionX, aScreenCssPositionY, aCallback);
        this._annotations[annotation.getUID()] = annotation;

        return annotation;
    }

    public removeAnnotation(aAnnotation: Annotation) {
        let annotation = this._annotations[aAnnotation.getUID()];
        if (annotation !== undefined) {
            delete this._annotations[aAnnotation.getUID()];
            return true;
        }

        return false;
    }

    public viewChanged() {
        let view = this.sceneAPI.viewModeModule.getActiveView();

        for (let key in this._annotations) {
            let annotation = this._annotations[key];
            annotation.updateScreenPositionAndOcclusion(view);
        }
    }

    public viewResized(aContentSize: vec2) {
        this.viewChanged();
    }
}

Scene.registerSceneAPIModule(AnnotationsModule);
